"use client"

import { Routes } from "@/lib/routes"
import { useSession } from "next-auth/react"

export function FooterSignUpButton() {
   const { status } = useSession()

   if (status !== "unauthenticated") return null

   return (
      <a
         href={Routes.client.unifiedSignup.getPath()}
         className="inline-block rounded-lg bg-custom-primary px-12 py-3 text-[20px] font-bold text-white shadow-lg transition-all duration-200 hover:bg-orange-600"
      >
         Sign Up
      </a>
   )
}
